import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { isPresent } from 'services/operators';
import { ApplicationConfigService } from 'services/application-config.service';
import { createRequestOption } from 'app/shared/util/request-util';
import { getInsuranceItemIdentifier, GlobalInsurance, IInsuranceItem } from '../models/insurance-item.model';
import { ApiProviderService } from './api-provider.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { IBaryTableFetchService, TableOptions } from './i-bary-table-fetch-service';
import { mapAsBody } from '../app/shared/util/request-util';

export type EntityResponseType = HttpResponse<IInsuranceItem>;
export type EntityArrayResponseType = HttpResponse<IInsuranceItem[]>;

@Injectable({ providedIn: 'root' })
export class InsuranceItemService implements IBaryTableFetchService<IInsuranceItem> {
  protected resourceUrl = API_ENDPOINTS.INSURANCE_ITEMS;
  protected insuranceItemsIdUrl = API_ENDPOINTS.INSURANCE_ITEMS_ID;
  protected insuranceItemsByOfferIdUrl = API_ENDPOINTS.INSURANCE_ITEMS_OFFER_ID;
  protected insuranceItemsGlobal = API_ENDPOINTS.INSURANCE_ITEMS_GLOBAL;
  protected insuranceItemsGlobalByName = API_ENDPOINTS.INSURANCE_ITEMS_GLOBALBYNAME;

  constructor(protected http: HttpClient, protected apiProvider: ApiProviderService, protected applicationConfigService: ApplicationConfigService) {}

  fillDataToShow(entities: IInsuranceItem[]): Observable<IInsuranceItem[]> {
    return of(entities);
  }

  saveForOffer(insuranceItems: IInsuranceItem[], offerId: number): Observable<EntityArrayResponseType> {
    return this.apiProvider.put<IInsuranceItem[]>(this.insuranceItemsByOfferIdUrl(offerId), insuranceItems);
  }

  find(id: number): Observable<EntityResponseType> {
    return this.apiProvider.get<IInsuranceItem>(this.insuranceItemsIdUrl(id));
  }

  findAllByOfferId(id: number): Observable<EntityArrayResponseType> {
    const params = new HttpParams().append('offerId.equals', id);
    return this.apiProvider.publicGet<IInsuranceItem[]>(`${this.insuranceItemsByOfferIdUrl(id)}`, {
      params,
      observe: 'response',
    });
  }

  query(req?: any, tableOption?: TableOptions): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider.publicGet<IInsuranceItem[]>(this.insuranceItemsByOfferIdUrl(tableOption?.identifier), {
      params: options,
      observe: 'response',
    });
  }

  updateOrder(insuranceItems: IInsuranceItem[], tableOption?: TableOptions): Observable<IInsuranceItem[]> {
    return this.apiProvider.put<IInsuranceItem[]>(this.insuranceItemsByOfferIdUrl(tableOption?.identifier), insuranceItems).pipe(mapAsBody);
  }

  updateGlobal(globalInsurance: GlobalInsurance): Observable<GlobalInsurance> {
    return this.apiProvider.put<GlobalInsurance>(this.insuranceItemsGlobal(), globalInsurance).pipe(mapAsBody);
  }

  getGlobal(): Observable<GlobalInsurance> {
    return this.apiProvider.get<GlobalInsurance>(this.insuranceItemsGlobal()).pipe(mapAsBody);
  }

  // updateGlobalByName(globalInsurance: GlobalInsurance,offers:OfferViewDTO[]): Observable<GlobalInsurance> {
  //   let objectTab : Object[] = []
  //   objectTab.push(globalInsurance)
  //   objectTab.push(offers)
  //   return this.apiProvider.put<GlobalInsurance>(this.insuranceItemsGlobalByName(), objectTab)
  //

  updateGlobalByName(globalInsurance: GlobalInsurance): Observable<GlobalInsurance> {
    return this.apiProvider.put<GlobalInsurance>(this.insuranceItemsGlobalByName(), globalInsurance).pipe(mapAsBody);
  }

  create(insuranceItem: IInsuranceItem, tableOption?: TableOptions): Observable<EntityResponseType> {
    return this.apiProvider.post<IInsuranceItem>(this.insuranceItemsByOfferIdUrl(tableOption?.identifier), insuranceItem);
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.apiProvider.delete(`${this.resourceUrl}/${id}`);
  }

  update(insuranceItem: IInsuranceItem): Observable<EntityResponseType> {
    return this.apiProvider.put<IInsuranceItem>(`${this.resourceUrl}/${getInsuranceItemIdentifier(insuranceItem)}`, insuranceItem);
  }

  addInsuranceItemToCollectionIfMissing(insuranceItemCollection: IInsuranceItem[], ...insuranceItemsToCheck: (IInsuranceItem | null | undefined)[]): IInsuranceItem[] {
    const insuranceItems: IInsuranceItem[] = insuranceItemsToCheck.filter(isPresent);
    if (insuranceItems.length > 0) {
      const insuranceItemCollectionIdentifiers = insuranceItemCollection.map(insuranceItemItem => getInsuranceItemIdentifier(insuranceItemItem));
      const insuranceItemsToAdd = insuranceItems.filter(insuranceItemItem => {
        const insuranceItemIdentifier = getInsuranceItemIdentifier(insuranceItemItem);
        if (insuranceItemIdentifier == null || insuranceItemCollectionIdentifiers.includes(insuranceItemIdentifier)) {
          return false;
        }
        insuranceItemCollectionIdentifiers.push(insuranceItemIdentifier);
        return true;
      });
      return [...insuranceItemsToAdd, ...insuranceItemCollection];
    }
    return insuranceItemCollection;
  }

  // InsuranceItemToGlobalInsurance(
  //   insuranceItem: InsuranceItem
  // ): GlobalInsurance {
  //  const globalInsurance = new GlobalInsurance();
  //  globalInsurance.insuranceChoice = insuranceItem. ;
  //   const insuranceItems: IInsuranceItem[] = insuranceItemsToCheck.filter(isPresent);
  //   if (insuranceItems.length > 0) {
  //     const insuranceItemCollectionIdentifiers = insuranceItemCollection.map(
  //       insuranceItemItem => getInsuranceItemIdentifier(insuranceItemItem)!
  //     );
  //     const insuranceItemsToAdd = insuranceItems.filter(insuranceItemItem => {
  //       const insuranceItemIdentifier = getInsuranceItemIdentifier(insuranceItemItem);
  //       if (insuranceItemIdentifier == null || insuranceItemCollectionIdentifiers.includes(insuranceItemIdentifier)) {
  //         return false;
  //       }
  //       insuranceItemCollectionIdentifiers.push(insuranceItemIdentifier);
  //       return true;
  //     });
  //     return [...insuranceItemsToAdd, ...insuranceItemCollection];
  //   }
  //   return insuranceItemCollection;
  // }
}
